export enum DifficultyModeEnum {
  ExpertPlus = "ExpertPlus",
  Expert = "Expert",
  Hard = "Hard",
  Normal = "Nomal",
  Easy = "Easy"
}

export enum CharacteristicNameEnum {
  Standard = "Standard",
  OneSaber = "OneSaber",
  NoArrows = "NoArrows"
}

export enum EnvironmentEnum {
  Default = "DefaultEnvironment",
  Nice = "NiceEnvironment"
}
